interface AddressVariables {
    address1?: string | null | undefined
    city?: string | null | undefined
    state?: string | null | undefined
    zip?: string | null | undefined
}

const render = (component: string | null | undefined): string => {
    if (component) {
        return `${component},`
    }
    return ''
}

export const encodeMapURI = (address: AddressVariables): string | undefined => {
    const { address1, city, state, zip } = address

    if (!city && !state && !zip) {
        return undefined
    }

    //TODO: Do we want to put the address2 here in the link?
    return encodeURI(`https://maps.google.com/?q=${render(address1)}${render(city)}${render(state)}${render(zip)}/`)
}
